import React, { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#services", label: "Services" },
  { href: "#process", label: "Process" },
  { href: "#pricing", label: "Pricing" },
  { href: "#about", label: "About" },
  { href: "#compliance", label: "Compliance" },
  { href: "#faq", label: "FAQ" },
];

const Navigation = () => {
  const [open, setOpen] = useState(false);

  const handleClick = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleBook = (e) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector("#booking");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="main-navigation"
      className="sticky top-0 z-50 bg-white border-b-2 border-black"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          onClick={(e) => handleClick(e, "#top")}
          data-testid="nav-logo"
          className="flex items-center gap-2 font-display font-black text-xl md:text-2xl tracking-tight"
        >
          <span className="inline-flex items-center justify-center w-8 h-8 bg-[#FACC15] border-2 border-black">
            <span className="text-black font-black text-sm">BP</span>
          </span>
          <span>Banana<span className="text-[#EAB308]">.</span>Paraplanner</span>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => handleClick(e, l.href)}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-bold uppercase tracking-wide text-black hover:text-[#EAB308] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a
            href="#booking"
            onClick={handleBook}
            data-testid="nav-book-cta"
            className="inline-block bg-[#FACC15] text-black border-2 border-black font-bold uppercase text-sm tracking-wide py-3 px-5 shadow-brutal hover-lift"
          >
            Book a Call
          </a>
        </div>

        <button
          type="button"
          className="lg:hidden border-2 border-black p-2"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden border-t-2 border-black bg-white px-6 py-4"
        >
          <ul className="flex flex-col gap-3">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={(e) => handleClick(e, l.href)}
                  className="block text-sm font-bold uppercase tracking-wide py-2 border-b border-black/10"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#booking"
                onClick={handleBook}
                className="mt-2 inline-block bg-[#FACC15] text-black border-2 border-black font-bold uppercase text-sm tracking-wide py-3 px-5 shadow-brutal"
              >
                Book a Call
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Navigation;
